import { promiseState, WithPromiseState } from 'annotation-tools/utils';
import { FetchListErrorReasonType } from './error-reason-type';

export type ListItemUnresolvedValue<T> = { latest: T | undefined };
export type ListItemErrorValue<T> = {
  latest: T | undefined;
  reason: 'item-not-found' | FetchListErrorReasonType;
};
export type ListItemSuccessValue<T> = { latest: T };

export type ListItemWithPromiseState<T> = WithPromiseState<
  ListItemUnresolvedValue<T>,
  ListItemErrorValue<T>,
  ListItemSuccessValue<T>
>;

export const listItemWithPromiseStateInit = <
  T
>(): ListItemWithPromiseState<T> => ({
  value: { latest: undefined },
  status: promiseState.pending
});
